import { FpCorrelationTabs } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/enums/fp-correlation-tabs.enum';
import { _ } from '@ngx-translate/core';

export const FpCorrelationTabsLocalize = {
  [FpCorrelationTabs.CorrelationGraph]: _('@@leak-detection-floating-popup-correlation-tab-correlation-graph'),
  [FpCorrelationTabs.CorrelationSpectrum]: _('@@leak-detection-floating-popup-correlation-tab-correlation-spectrum'),
  [FpCorrelationTabs.Summary]: _('@@shared-summary'),
  [FpCorrelationTabs.Comments]: _('@@shared-comments'),
};
